import React, { useState,  useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentUserId, setToken, setisLogin, setisAdmin, getProfile, createProfile, setDateUser, setNameUser } from '../slices/userSlise';
import Risk2Service from '../services/risk2-services';
import axios from 'axios';
import Main from './Main';
import { Modal} from "antd";
import '../App.css';
import ProfileSettingsService from '../services/profileSettings-service';
import countries from '../utils/countries';
import Sidebar from '../components/Sidebar';
const Lkabinet = () => {
	const storedAuthToken = localStorage.getItem("authToken");
	// const currentUserId = localStorage.getItem("CurrentUserId");
	// const host = '92.205.162.68';
	const host = '212.3.155.91'
	const API_URL = process.env.REACT_APP_API_BASE_URL;
	const  user  = useSelector((state) => state.user);
	const navigate = useNavigate();
	const [data, setData] = useState({risks: []});
	const [userData, setUserData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
  	const [error, setError] = useState(null);
	const [openSignUp , setOpenSignUp] = useState(false)
	const [day, setDay] = useState(userData ? userData.day : 1);
	const [monthBirthday, setMonthBirthday] = useState(userData ? userData.monthBirthday : "1");
    const [yearBirthday, setYearBirthday] = useState(userData ? userData.yearBirthday : new Date().getFullYear());
	const [gender, setGender] = useState(userData ? userData.gender : "");
	// const [username, setName] = useState((userData != null) ? userData.username : "");
	const [username, setName] = useState("");

	// console.log(username);
	const [userLastName, setLastName] = useState(userData ? userData.userLastName : "");
    const [password, setPassword] = useState(userData ? userData.password : "");
	const [workExperience, setWorkExperience] = useState(userData ? userData.workExperience : "");
	const [hseBio, setHSEBio] = useState(userData ? userData.hseBio : "");
	const [educationLevel, setEducationLevel] = useState(userData ? userData.educationLevel : "");
	const [otherEducational, setOtherEducational] = useState(userData ? userData.otherEducational : "");
    const [contact, setContact] = useState(userData ? userData.contact : "");
	const [language, setLanguage] = useState(userData ? userData.language : "1");
	const [oldPassword, setOldPassword] = useState(userData ? userData.oldPassword : "");
	const [newPassword, setNewPassword] = useState(userData ? userData.newPassword : "");
	// const [email, setEmail] = useState(userData ? userData.email : "");
	const [email, setEmail] = useState('');
    const [yearOfWork, setYearOfWork] = useState(userData ? userData.yearOfWork : "");
	const [monthOfWork, setMonthOfWork] = useState(userData ? userData.monthOfWork : "");
	const currentUserId = user.currentUserId;
	const [whoAmI, setWhoAmI] = useState('user');

	const [isVisible, setIsVisible] = useState(false)

	useEffect(() => {
		setEmail(user.email)
	}, [user])

	useEffect(() => {
		if(storedAuthToken && user.isLogin){
			async function getRisks(){
				const risks2 = await Risk2Service.getAllRisks2()
				setData({risks: risks2});
			}
			getRisks()
		}

	}, [user, storedAuthToken])
	useEffect(() => {
		if(storedAuthToken && user.isLogin){
			async function getProfile(){
				const profile = await ProfileSettingsService.getOneProfile(user.currentUserId);
				if(!!profile){
					dispatch(setNameUser(profile.username));
					setUserData(profile);
					setName(profile.username);
					setLastName(profile.userLastName);
				}					
			}
			getProfile()
		}

	}, [user, storedAuthToken])
	  
	const closeModalSignUp = () => {
		setOpenSignUp(false)
	}
	const handleDayChange = (value) => {
		console.log(value)
		setDay(value);
	  };
	const generateDays = () => {
		const days = [];
		for (let i = 1; i <= 31; i++) {
		  days.push(
			<option key={i} value={i}>
			  {i}
			</option>
		  );
		}
		return days;
	  };
	const currentYear = new Date().getFullYear();
  	const years = [];
  	for (let year = currentYear; year >= currentYear - 80; year--) {
    	years.push(year);
  	}
	const [selectedCountry, setSelectedCountry] = useState(userData ? userData.selectedCountry : "");
	
	const handleChange = (event) => {
		setSelectedCountry(event.target.value);
	};
	
  	const dispatch = useDispatch();
	const handleOnSubmit = async (e) => {
        e.preventDefault();
		try {
			dispatch(createProfile({ 
				currentUserId,
				username,	
				userLastName, 
				oldPassword, 
				newPassword, 
				password, 
				email, 
				contact, 
				language, 
				day, 
				monthBirthday, 
				yearBirthday, 
				gender, 
				selectedCountry, 
				educationLevel, 
				otherEducational,
				monthOfWork,
				yearOfWork,
				workExperience,
				hseBio,
			}));
			setOpenSignUp(true);
		} catch (error) {
			console.log(error);
		}
    }
	const handleOnUpdate = async (e) => {
        e.preventDefault();
		let result = await fetch(
			// `http://${host}:3001/profile/update/${currentUserId}`, {
			`${API_URL}/profile/update/${currentUserId}`, {
				method: "put",
				body: JSON.stringify({ 	
					userId: currentUserId,
					username,
					userLastName, 
					oldPassword, 
					newPassword, 
					password, 
					email, 
					contact, 
					language, 
					day, 
					monthBirthday, 
					yearBirthday, 
					gender, 
					selectedCountry, 
					educationLevel, 
					otherEducational,
					monthOfWork,
					yearOfWork,
					workExperience,
					hseBio,
				}),
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${storedAuthToken}`
				}
			}
		)
		result = await result.json();
		console.log("LK result", result)
		if (result.message) {
			console.log("login error", result)
			setError(result.message);
		} else {
			dispatch(setToken(result.token));
			setError(null);
			dispatch(setisLogin(true));
			//dispatch(setCurrentUserId(result.user.id));
			//setOpenSignUp(true);
			//navigate('/');
		}
		setOpenSignUp(true);
		setPassword('')
		setOldPassword('')
		setNewPassword('')
	}
	useEffect(() => {
		if(user.isAdmin){
			setWhoAmI('admin')
		}else if(user.isReviewer){
			setWhoAmI('reviewer')
		}else if(user.isApprover){
			setWhoAmI('approver')
		}
	}, [user])
	// console.log(data)
	const renderCurrentNotification = () => {
		switch (whoAmI) {
			case "user":
				return (
					<>
					<span className="iconnoty2"> 
						<span className="iconnoty-count">
							{data.risks.filter(item => item.userid == user.currentUserId).length}
						</span> 
					</span>
					</>
				)
			case "admin":
				return (
					<>
						<span className="iconnoty2"> 
							<span className="iconnoty-count">{data.risks.filter(item => !item.approve && !item.decline && !item.saved && item.statusReview == '1' && item.statusApprove == '1').length}</span>
						</span>
					</>
				)
			case "reviewer":
				return (
					<>
						<span className="iconnoty2"> 
							<span className="iconnoty-count">
								{
									data.risks.filter(item => !item.approve && !item.decline && !item.saved && item.statusReview == '0').length +
									data.risks.filter(item => item.userid == user.currentUserId).length
								}
							</span>
						</span>
					</>
				)
			case "approver":
				return (
					<>
						<span className="iconnoty2"> 
							<span className="iconnoty-count">
								{
									data.risks.filter(item => !item.approve && !item.decline && !item.saved && item.statusReview == '1' && item.statusApprove == '0').length +
									data.risks.filter(item => item.userid == user.currentUserId).length
								}
							</span>
						</span>
					</>
				)
			default:
				return null;
		}
	}
	return (
		<div>
			{storedAuthToken ? 
			<main>
				<div className="container">
					<div className="lk-lefttoright">
						<div className="lk-lefttoright-l">
							<div className="maxforms">
								<div className="lkblockedits">
									<form className="setting-table" method="post" target="_top" action="" >
										<div className="heads-form">
											<div className="heads-form1">Profile settings</div>
											<div className="heads-form2"><img src="/img/account_box.svg"/><span className="textfr">Edit</span><span className="editicon fellow"></span></div>
										</div>
										<div className="body-form">
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Profile name</div>
												<div className="form-one-blocks2">
													<div className="form-one-blocks3">
														<input type="text" className="input" name="NAME" value={username} onChange={(e) => setName(e.target.value)} placeholder={userData ? userData.username : "First Name"} />
														<span className="editicon"></span>
													</div>
													<div className="form-one-blocks3">
														<input   type="text" className="input"  name="LAST_NAME" value={userLastName} onChange={(e) => setLastName(e.target.value)}  placeholder={userData ? userData.userLastName : "Last Name"}/>
														<span className="editicon"></span>
													</div>
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">email</div>
												<div className="form-one-blocks2">
													<div className="form-one-blocks3">
														<input type="text" className="input" name="EMAIL" placeholder={user.email}  value={email} onChange={(e) => setEmail(e.target.value)}/>
														<span className="editicon"></span>
													</div>														 
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Password</div>
												<div className="form-one-blocks2">
												<div className="form-one-blocks3">
														<input type="password" className="input jsshowpass3" name="OLD_PASSWORD" placeholder="Old password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)}/>
														<span className="editicon"></span>
													</div>
													<div className="form-one-blocks3">
														<input type="password" className="input jsshowpass3" name="NEW_PASSWORD" placeholder="New password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}/>
														<span className="editicon"></span>
													</div>
													<div className="form-one-blocks3">
														<input className="input jsshowpass3"  type="password"  name="NEW_PASSWORD_CONFIRM"  autoComplete="off" placeholder="Confirm new password" value={password} onChange={(e) => setPassword(e.target.value)}/>
														<span className="editicon"></span>
													</div>												 
												</div>
											</div>
											
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Contact no.</div>
												<div className="form-one-blocks2">
													<div className="form-one-blocks3">
														<input type="text" className="input" name="UF_CONTNO" placeholder={userData ? userData.contact : "Contact No."} value={contact} onChange={(e) => setContact(e.target.value)} />
														<span className="editicon"></span>
													</div>											 
												</div>
											</div>
											
											<div className="form-one-blocks">
												<div className="form-one-blocks1">language</div>
												<div className="form-one-blocks2">
													<div className="form-is-select">
														<select value={language} onChange={(e) => setLanguage(e.target.value)}>
															<option  value="1">English</option>
															<option  value="2">Russian</option>
														</select>
													</div>												
												</div>
											</div>
											
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Birthday</div>
												<div className="form-one-blocks2">
													<div className="form-is-select">
														<select value={monthBirthday} onChange={(e) => setMonthBirthday(e.target.value)}>
															<option  value="1">January</option>
															<option  value="2">February</option>
															<option  value="3">March</option>
															<option  value="4">April</option>
															<option  value="5">May</option>
															<option  value="6">June</option>
															<option  value="7">July</option>
															<option  value="8">August</option>
															<option  value="9">September</option>
															<option  value="10">October</option>
															<option  value="11">November</option>
															<option  value="12">December</option>
														</select>
													</div>
													
													<div className="form-is-select">
														<select id="day" name="day" value={day} onChange={(e) => handleDayChange(e.target.value)} >
															{generateDays()}
														</select>
													</div>
													
													<div className="form-is-select">
														<select id="yearSelect" value={yearBirthday} onChange={(e) => setYearBirthday(e.target.value)}>
															{years.map((year, index) => (
															<option key={index} value={year}>
																{year}
															</option>
															))}
														</select>
													</div>											 
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Gender</div>
												<div className="form-one-blocks2">
													<div className="form-is-select">
														<select name="gender" id="gender" value={gender} onChange={(e) => setGender(e.target.value)}>
															
															<option value="male">Male</option>
															<option value="female">Female</option>
															<option value="other">Other</option>
														</select>
													</div>												
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Nationality</div>
												<div className="form-one-blocks2">
													<div className="form-is-select">
														<select id="nationality" value={selectedCountry} onChange={handleChange}>
															{countries.map((country) => (
															<option key={country.value} value={country.label}>
																{country.label}
															</option>
															))}
														</select>
													</div>												
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Education level</div>
												<div className="form-one-blocks2">
													<div className="form-one-blocks3">
														<input type="text" className="input"  placeholder={userData ? userData.educationLevel : "Level"} value={educationLevel} onChange={(e) => setEducationLevel(e.target.value)} />
														<span className="editicon"></span>
													</div>											 
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Other educational experience</div>
												<div className="form-one-blocks2">
													<div className="form-one-blocks3">
														<input type="text" className="input" placeholder={userData ? userData.educationLevel : "Level"} value={otherEducational} onChange={(e) => setOtherEducational(e.target.value)}/>
														<span className="editicon"></span>
													</div>											 
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Year of work Experience</div>
												<div className="form-one-blocks2">
													<div className="form-is-select">
														<select id="yearOfWorkSelect" value={yearOfWork} onChange={(e) => setYearOfWork(e.target.value)}>
															{years.map((year, index) => (
															<option key={index} value={year}>
																{year}
															</option>
															))}
														</select>
													</div>	
													<div className="form-is-select">
														<select value={monthOfWork} onChange={(e) => setMonthOfWork(e.target.value)}>
															<option  value="1">January</option>
															<option  value="2">February</option>
															<option  value="3">March</option>
															<option  value="4">April</option>
															<option  value="5">May</option>
															<option  value="6">June</option>
															<option  value="7">July</option>
															<option  value="8">August</option>
															<option  value="9">September</option>
															<option  value="10">October</option>
															<option  value="11">November</option>
															<option  value="12">December</option>
														</select>
													</div>										 
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">Work Experience</div>
												<div className="form-one-blocks2">
													<div className="form-one-blocks3">
														<input type="text" className="input"  placeholder={userData ? userData.workExperience : "Experience"} value={workExperience} onChange={(e) => setWorkExperience(e.target.value)} />
														<span className="editicon"></span>
													</div>											 
												</div>
											</div>
											<div className="form-one-blocks">
												<div className="form-one-blocks1">HSE Bio</div>
												<div className="form-one-blocks2">
													<div className="form-one-blocks3">
														<textarea aria-rowcount={2} className="input"  placeholder={userData ? userData.hseBio : "Text here"} value={hseBio} onChange={(e) => setHSEBio(e.target.value)}/>
														<span className="editicon"></span>
													</div>											 
												</div>
											</div>
											{error ? <div style={{color: "red"}}>{error}</div> : <></>}
										</div>
										<div className="footer-form">
											{userData ? 
												<input type="submit" value="save" className="buttonsave" onClick={handleOnUpdate}/>
											: 
												<input type="submit" value="save" className="buttonsave" onClick={handleOnSubmit}/>
											}												
										</div>
									</form>
								</div>
							</div>
						</div>

						<div className="lk-lefttoright-r">
							<ul className="lk-menu">
								<li><Link to="/lk/" className="active">Profile setting</Link></li>
								<li><Link to="/lk/dashboard">Dashboard</Link></li>
								<li><Link to="/lk/notification">notification</Link></li>
							</ul>
						</div>
					</div>
					<Sidebar user={user} renderCurrentNotification={renderCurrentNotification} />
				</div>
			</main>
			: <Main />
			}
			<div>
				<Modal style={{padding: 0, border: "1px solid #E7DB59", borderRadius: "4px"}} open={openSignUp} onCancel={closeModalSignUp} id="getmylogin"  footer={null}>
					<div className="succespopup aboutforms">
						<div className="succtext1">You have successfully signed up</div>
						<div className="succtext1"><img src="/img/task_alt.svg"/></div>
						<div data-fancybox-close className="succtext3"  type="button" onClick={closeModalSignUp}>ok</div>
					</div>
				</Modal>
			</div>
		</div>
	)
}
export default Lkabinet;